import { Link } from 'react-router-dom'
import './Home.css'
import visimapIcon from './Media/VisiMap.png'
import { useState } from 'react'

const Home = () => {
    const [activeSection, setActiveSection] = useState('applications')

    const renderContent = () => {
        switch(activeSection) {
            case 'applications':
                return (
                    <section className="applications-section">
                        <div className="apps-grid">
                            <Link to="/visimap" className="app-card">
                                <img src={visimapIcon} alt="VisiMap" className="app-icon" />
                                <h3>VisiMap</h3>
                                <p>Turn spreadsheets into maps.</p>
                                <span className="app-version">v3.3</span>
                            </Link>
                        </div>
                    </section>
                )
            default:
                return null
        }
    }

    return (
        <div className="home-layout">
            <aside className="home-sidebar">
                <nav className="sidebar-nav">
                    <button
                        className={activeSection === 'applications' ? 'active' : ''}
                        onClick={() => setActiveSection('applications')}
                    >
                        Applications
                    </button>
                </nav>
            </aside>

            <main className="home-content">
                {renderContent()}
            </main>
        </div>
    )
}

export default Home